import { ImageTemplates } from "~/components/Image";
import { WindowFormat } from "~/hooks/useBreakpoints";

export const IMAGE_TEMPLATES: ImageTemplates = {
  [WindowFormat.MOBILE]: "banner-mobile",
  [WindowFormat.TABLET]: "banner-tablet",
  [WindowFormat.DESKTOP]: "banner-regulardesktop",
  [WindowFormat.WIDE_DESKTOP]: "banner-largedesktop",
};
